import { IDishFullInfoState } from './dishFullInfoContext';
import { DishFullInfoActionTypes, TDishFullInfoAction } from './dishFullInfoActions';

export const dishFullInfoReducer = (state: IDishFullInfoState, action: TDishFullInfoAction): IDishFullInfoState => {
	switch (action.type) {
		case DishFullInfoActionTypes.CHANGE_DISH_FULL_INFO_VISIBLE_FORM:
			return {
				...state,
				dishFullInfoVisibleForm: action.payload.visibleForm,
			};
		case DishFullInfoActionTypes.SET_DISH_FOR_FULL_INFO:
			return {
				...state,
				dishForFullInfo: action.payload.dish,
			};
		default:
			return state;
	}
};
